import React from 'react'
import { Modal, Table, Typography } from 'antd'
import { BankOutlined } from '@ant-design/icons'

const { Title, Text } = Typography

const CostCenterModal = ({ visible, onClose, costCenterData, vendorName }) => {
  const tableData = costCenterData?.costCenterPurposeList
    ? costCenterData.costCenterPurposeList.map((item, index) => ({
      key: item._id || index.toString(),
      costCenter: item.costCenter || 'N/A',
      purpose: item.purpose || 'N/A',
      // You can add percentage and amount fields if they exist in your data
      percentage: item.percentage || 'N/A',
      amount: item.amount || costCenterData.amount || 'N/A'
    }))
    : []

  const columns = [
    {
      title: 'Cost Center',
      dataIndex: 'costCenter',
      key: 'costCenter',
      width: '50%',
      render: (text) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <BankOutlined style={{ color: '#ad0270' }} />
          <Text strong>{text}</Text>
        </div>
      )
    },
    {
      title: 'Purpose',
      dataIndex: 'purpose',
      key: 'purpose',
      width: '50%',
      render: (text) => <Text>{text}</Text>
    }
    // Uncomment these columns if you have percentage and amount data
    // {
    //   title: 'Percentage',
    //   dataIndex: 'percentage',
    //   key: 'percentage',
    //   width: '15%',
    //   render: (text) => <Text>{text}</Text>
    // },
    // {
    //   title: 'Amount',
    //   dataIndex: 'amount',
    //   key: 'amount',
    //   width: '15%',
    //   render: (text) => <Text>{text}</Text>
    // }
  ]

  return (
    <Modal
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <BankOutlined style={{ fontSize: '20px', color: '#ad0270' }} />
          <div>
            <Title level={4} style={{ margin: 0 }}>
              Cost Center Details
            </Title>
            <Text type="secondary">
              Vendor: {vendorName}
            </Text>
          </div>
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      width={700}
      destroyOnClose
    >
      <div style={{ marginTop: '16px' }}>
        {tableData.length > 0 ? (
          <>
            <div style={{ marginBottom: '12px' }}>
              <Text type="secondary">
                {tableData.length} Cost Center{tableData.length > 1 ? 's' : ''} Found
              </Text>
            </div>
            <Table
              columns={columns}
              dataSource={tableData}
              pagination={false}
              size="middle"
              bordered
              scroll={{ y: 400 }}
            />
          </>
        ) : (
          <div
            style={{
              textAlign: 'center',
              padding: '40px',
              backgroundColor: '#fafafa',
              borderRadius: '8px'
            }}
          >
            <BankOutlined
              style={{
                fontSize: '48px',
                color: '#d9d9d9',
                marginBottom: '16px'
              }}
            />
            <br />
            <Text type="secondary">
              No cost center information available for this RFP.
            </Text>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default CostCenterModal
